<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="email-detail-dialog"
  [style]="{ width: '90vw', maxWidth: '1000px' }"
  [contentStyle]="{ padding: '0' }"
  (onHide)="close()"
>
  <ng-template pTemplate="header">
    <div class="dialog-header">
      <h3>
        <i class="fa-solid fa-envelope"></i>
        Detalle de Email
      </h3>
      <span 
        *ngIf="email" 
        class="status-badge"
        [style.background-color]="getStatusInfo().color"
      >
        <i [class]="getStatusInfo().icon"></i>
        {{ getStatusInfo().label }}
      </span>
    </div>
  </ng-template>

  <div class="email-detail-content" *ngIf="email">
    <!-- Header con estado -->
    <div class="detail-header">
      <div class="status-badge-large" [style.background-color]="getStatusInfo().color">
        <i [class]="getStatusInfo().icon"></i>
        <span>{{ getStatusInfo().label }}</span>
      </div>
      <p class="status-description">{{ getStatusInfo().description }}</p>
    </div>

    <!-- Información del Email -->
    <div class="detail-section">
      <h4 class="section-title">
        <i class="fa-solid fa-info-circle"></i>
        Información del Email
      </h4>
      <div class="grid">
        <div class="col-12 md:col-6">
          <div class="info-item">
            <label>Destinatario:</label>
            <span>{{ email.recipientEmail || email.to }}</span>
          </div>
        </div>
        <div class="col-12 md:col-6">
          <div class="info-item">
            <label>Nombre:</label>
            <span>{{ email.recipientName || email.clientName }}</span>
          </div>
        </div>
        <div class="col-12">
          <div class="info-item">
            <label>Asunto:</label>
            <span>{{ email.subject }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Información de la Campaña -->
    <div class="detail-section">
      <h4 class="section-title">
        <i class="fa-solid fa-bullseye"></i>
        Información de la Campaña
      </h4>
      <div class="grid">
        <div class="col-12 md:col-6">
          <div class="info-item">
            <label>Estrategia:</label>
            <span>{{ email.campaignStrategyName || 'N/A' }}</span>
          </div>
        </div>
        <div class="col-12 md:col-6">
          <div class="info-item">
            <label>Lease:</label>
            <span>{{ email.leaseNumber || 'N/A' }}</span>
          </div>
        </div>
        <div class="col-12 md:col-6">
          <div class="info-item">
            <label>Cliente:</label>
            <span>{{ email.clientName || 'N/A' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Métricas de Engagement -->
    <div class="detail-section" *ngIf="showEngagementMetrics()">
      <h4 class="section-title">
        <i class="fa-solid fa-chart-line"></i>
        Engagement
      </h4>
      <div class="grid">
        <div class="col-12 md:col-6">
          <div class="info-item">
            <label>Aperturas:</label>
            <span class="engagement-value">
              <i class="fa-solid fa-envelope-open"></i>
              {{ email.openCount || 0 }}
            </span>
          </div>
        </div>
        <div class="col-12 md:col-6">
          <div class="info-item">
            <label>Clicks:</label>
            <span class="engagement-value">
              <i class="fa-solid fa-hand-pointer"></i>
              {{ email.clickCount || 0 }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Timeline -->
    <div class="detail-section">
      <h4 class="section-title">
        <i class="fa-solid fa-clock"></i>
        Timeline
      </h4>
      <div class="grid">
        <div class="col-12 md:col-6" *ngIf="email.sentAt">
          <div class="info-item">
            <label>Enviado:</label>
            <span>{{ formatDate(email.sentAt) }}</span>
          </div>
        </div>
        <div class="col-12 md:col-6" *ngIf="email.deliveredAt">
          <div class="info-item">
            <label>Entregado:</label>
            <span>{{ formatDate(email.deliveredAt) }}</span>
          </div>
        </div>
        <div class="col-12 md:col-6" *ngIf="email.openedAt">
          <div class="info-item">
            <label>Abierto:</label>
            <span>{{ formatDate(email.openedAt) }}</span>
          </div>
        </div>
        <div class="col-12 md:col-6" *ngIf="email.clickedAt">
          <div class="info-item">
            <label>Último Click:</label>
            <span>{{ formatDate(email.clickedAt) }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Metadata del Proveedor -->
    <div class="detail-section" *ngIf="email.providerMetadata">
      <h4 class="section-title">
        <i class="fa-solid fa-server"></i>
        Metadata del Proveedor
      </h4>
      <pre class="metadata-display">{{ email.providerMetadata | json }}</pre>
    </div>

    <!-- Error (si existe) -->
    <div class="detail-section error-section" *ngIf="email.error">
      <h4 class="section-title">
        <i class="fa-solid fa-exclamation-circle"></i>
        Error
      </h4>
      <div class="error-content">
        <p><strong>Tipo:</strong> {{ email.error.type }}</p>
        <p><strong>Mensaje:</strong> {{ email.error.message }}</p>
      </div>
    </div>

    <!-- Acciones rápidas -->
    <div class="detail-actions mt-3">
      <button 
        pButton 
        label="Ver Tracking" 
        icon="fa-solid fa-timeline"
        class="p-button-outlined"
        (click)="openTracking()"
      ></button>
      <button 
        pButton 
        label="Ver HTML" 
        icon="fa-solid fa-code"
        class="p-button-outlined p-button-info"
        (click)="openPreview()"
        *ngIf="email.bodyHtml"
      ></button>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button 
        pButton 
        label="Cerrar" 
        icon="fa-solid fa-times"
        class="p-button-secondary"
        (click)="close()"
      ></button>
    </div>
  </ng-template>
</p-dialog>
